import { localStorageService } from "@Engage.Data/services/storage/localStorage/LocalStorageService";
export class BlockedCookiesOrLsQualifier {
    constructor() {
        this.key = "BlockedCookiesOrLs";
    }
    process() {
        // Returns "true" when cookies/localStorage are BLOCKED (not supported)
        // Mirrors ConneXt v2: value == !localStorageService.isSupported()
        const isBlocked = !localStorageService.isSupported();
        return isBlocked.toString();
    }
}
